import RoleTermsModal from './role-terms-modal';

export default RoleTermsModal;
